<template>
    <v-container fluid>
        <v-row class="d-flex justify-space-between">
            <v-col cols="4" class="text-left">
                <v-btn color="primary" @click="addClick">
                    <v-icon small>fa-plus</v-icon>&nbsp;&nbsp;{{ $t('buttons.add') }}
                </v-btn>
            </v-col>
            <v-col cols="4"></v-col>
            <v-col cols="4" class="text-right d-flex align-top justify-end">
                <v-checkbox class="d-inline mr-3 mt-1" v-model="selectAll" :label="$t('labels.selectAll')"></v-checkbox>
                <v-btn class="d-inline" color="primary" @click="copyCheckedEmailsToClipboard">
                    <v-icon small>fa-copy</v-icon>&nbsp;&nbsp;{{ $t('buttons.copyMails') }}
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" lg="12">
                <v-card flat outlined>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <TheTable
                                    :additional-filters="seafarersTable.additionalFilters"
                                    :default-sort="seafarersTable.defaultSort"
                                    :excel="true"
                                    :fields="seafarersTable.headers"
                                    :header-selection-key="'seafarers-sheaders'"
                                    :height="seafarersTable.height"
                                    :total-records="seafarersTable.total"
                                    :filter-save-key="'seafarers-sfilters'"
                                    @excel="excelExport"
                                    @headers="selectHeaders"
                                    @reload="reloadData"
                                >
                                    <tr
                                        v-for="(item, key) in seafarersTable.items"
                                        :key="key"
                                        :class="{'cursor-pointer': true}"
                                        @contextmenu.prevent="editClick(item.id, true)"
                                    >
                                        <td>
                                            <v-simple-checkbox :ripple="false" v-model="item.checked">
                                            </v-simple-checkbox>
                                        </td>
                                        <td
                                            class="text-right"
                                            v-if="seafarersTable.selectedHeaders.includes('id')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.id }}
                                        </td>
                                        <td
                                            class="text-center"
                                            v-if="seafarersTable.selectedHeaders.includes('pending_status')"
                                            @click="editClick(item.id, false)"
                                        >
                                            <v-tooltip bottom v-if="item.pending_status == true">
                                                <template v-slot:activator="{on, attrs}">
                                                    <v-btn v-on="on" v-bind="attrs" x-small fab depressed>
                                                        <v-icon small color="red">fas fa-exclamation</v-icon></v-btn
                                                    ></template
                                                ><span>{{ $t('tooltips.pleaseEditActivitLog') }}</span></v-tooltip
                                            >
                                        </td>

                                        <td
                                            v-if="seafarersTable.selectedHeaders.includes('status_id')"
                                            @click="editClick(item.id, false)"
                                        >
                                            <!-- siva  -- inactive -->
                                            <v-chip
                                                v-if="item.status_id == 1"
                                                class="text-uppercase pl-4"
                                                text-color="#212528"
                                                color="#a3b8c9"
                                                ><v-icon x-small left color="#212528"> fas fa-circle </v-icon
                                                >{{ item.status_display }}</v-chip
                                            >
                                            <!--  roza -- sick leave -  -->
                                            <v-chip
                                                v-else-if="item.status_id == 2 || item.status_id == 6"
                                                class="text-uppercase pl-4"
                                                text-color="#ac8ea9"
                                                color="#f5cbf1"
                                                ><v-icon x-small left color="#ac8ea9"> fas fa-circle </v-icon
                                                >{{ item.status_display }}</v-chip
                                            >
                                            <!-- available -- zelena -->
                                            <v-chip
                                                v-else-if="item.status_id == 3"
                                                class="text-uppercase pl-4"
                                                text-color="#008000"
                                                color="#00800040"
                                                ><v-icon x-small left color="#008000"> fas fa-circle </v-icon
                                                >{{ item.status_display }}</v-chip
                                            >
                                            <!--  on leave -- bez boje   -->
                                            <v-chip
                                                v-else-if="item.status_id == 4"
                                                class="text-uppercase pl-4"
                                                text-color="#000000"
                                                color="#ffffff"
                                                ><v-icon x-small left color="#000000"> fas fa-circle </v-icon
                                                >{{ item.status_display }}</v-chip
                                            >
                                            <!--  travel to vessel; training,visa,etc.; travel from vessel -- žuta   -->
                                            <v-chip
                                                v-else-if="
                                                    item.status_id == 5 || item.status_id == 7 || item.status_id == 9
                                                "
                                                class="text-uppercase pl-4"
                                                text-color="#BBBB00"
                                                color="#E1E10040"
                                                ><v-icon x-small left color="#BBBB00"> fas fa-circle </v-icon
                                                >{{ item.status_display }}</v-chip
                                            >
                                            <!-- on board -- plava -->
                                            <v-chip
                                                v-else-if="item.status_id == 8"
                                                class="text-uppercase pl-4"
                                                text-color="#49707c"
                                                color="#92e0f7"
                                                ><v-icon x-small left color="#49707c"> fas fa-circle </v-icon
                                                >{{ item.status_display }}</v-chip
                                            >
                                        </td>
                                        <td
                                            v-if="seafarersTable.selectedHeaders.includes('name')"
                                            class="font-weight-bold"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.name }}
                                        </td>
                                        <td
                                            v-if="seafarersTable.selectedHeaders.includes('surname')"
                                            class="font-weight-bold"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.surname }}
                                        </td>
                                        <td
                                            v-if="seafarersTable.selectedHeaders.includes('nationality_id')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.nationality ? item.nationality.name : '' }}
                                        </td>
                                        <td
                                            v-if="seafarersTable.selectedHeaders.includes('age')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.age }}
                                        </td>
                                        <td
                                            v-if="seafarersTable.selectedHeaders.includes('available_date')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.available_date_display }}
                                        </td>

                                        <td
                                            v-if="seafarersTable.selectedHeaders.includes('rank_id')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.rank_display }}
                                        </td>

                                        <td
                                            class="text-center"
                                            v-if="seafarersTable.selectedHeaders.includes('next_planned_date')"
                                            @click="editClick(item.id, false)"
                                        >
                                            <v-chip
                                                v-if="item.next_planned_date != ' - '"
                                                class="text-uppercase pl-4"
                                                text-color="#BBBB00"
                                                color="#E1E10040"
                                                >{{ item.next_planned_date }}</v-chip
                                            >
                                            <span v-else>
                                                {{ item.next_planned_date }}
                                            </span>
                                        </td>
                                        <td
                                            v-if="seafarersTable.selectedHeaders.includes('overall')"
                                            @click="editClick(item.id, false)"
                                        >
                                            <v-rating
                                                v-model="item.overall"
                                                color="primary"
                                                background-color="grey darken-1"
                                                hover
                                                readonly
                                                small
                                                class="ma-0"
                                            ></v-rating>
                                        </td>
                                        <td
                                            class="text-center"
                                            v-if="seafarersTable.selectedHeaders.includes('approved')"
                                            @click="editClick(item.id, false)"
                                        >
                                            <v-btn v-if="item.approved" x-small color="#00800040" fab depressed>
                                                <v-icon x-small color="#008000">fas fa-check</v-icon></v-btn
                                            >
                                            <v-btn v-else x-small color="#6F6F6F40" fab depressed>
                                                <v-icon x-small color="#6F6F6F">fas fa-question</v-icon></v-btn
                                            >
                                        </td>
                                        <td
                                            class="truncate-content"
                                            v-if="seafarersTable.selectedHeaders.includes('rank_expirience_id')"
                                            @click="editClick(item.id, false)"
                                        >
                                            <v-tooltip top>
                                                <template v-slot:activator="{on, attrs}">
                                                    <span v-bind="attrs" v-on="on">
                                                        {{ item.rank_expirience }}
                                                    </span>
                                                </template>
                                                <span>{{ item.rank_expirience }}</span>
                                            </v-tooltip>
                                        </td>
                                        <td
                                            class="truncate-content"
                                            v-if="seafarersTable.selectedHeaders.includes('vessel_expirience_id')"
                                            @click="editClick(item.id, false)"
                                        >
                                            <v-tooltip top>
                                                <template v-slot:activator="{on, attrs}">
                                                    <span v-bind="attrs" v-on="on">
                                                        {{ item.vessel_expirience }}
                                                    </span>
                                                </template>
                                                <span>{{ item.vessel_expirience }}</span>
                                            </v-tooltip>
                                        </td>
                                        <td>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{on, attrs}">
                                                    <v-btn
                                                        icon
                                                        v-bind="attrs"
                                                        @click="editClick(item.id, true)"
                                                        v-on="on"
                                                    >
                                                        <v-icon small>fa-external-link-alt</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>{{ $t('tooltips.openInNewTab') }}</span>
                                            </v-tooltip>
                                            <v-tooltip bottom v-if="item.contract_placement_id != null">
                                                <template v-slot:activator="{on, attrs}">
                                                    <v-btn
                                                        v-on="on"
                                                        v-bind="attrs"
                                                        x-small
                                                        color="#00800040"
                                                        fab
                                                        depressed
                                                        class="mr-1"
                                                        @click="openPlacement(item.contract_placement_id)"
                                                    >
                                                        <v-icon x-small color="#008000"
                                                            >fas fa-arrow-right</v-icon
                                                        ></v-btn
                                                    >
                                                </template>
                                                <span>{{ $t('tooltips.goToContractPlacement') }}</span>
                                            </v-tooltip>
                                            <v-tooltip bottom v-if="item.planned_placement_id != null">
                                                <template v-slot:activator="{on, attrs}">
                                                    <v-btn
                                                        v-on="on"
                                                        v-bind="attrs"
                                                        x-small
                                                        color="#E1E10040"
                                                        fab
                                                        depressed
                                                        @click="openPlacement(item.planned_placement_id)"
                                                    >
                                                        <v-icon x-small color="#BBBB00"
                                                            >fas fa-arrow-right</v-icon
                                                        ></v-btn
                                                    >
                                                </template>
                                                <span>{{ $t('tooltips.goToPlannedPlacement') }}</span>
                                            </v-tooltip>
                                            <v-tooltip bottom v-if="item.planned_placement_id == null">
                                                <template v-slot:activator="{on, attrs}">
                                                    <v-btn
                                                        v-on="on"
                                                        v-bind="attrs"
                                                        x-small
                                                        color="#6F6F6F40"
                                                        fab
                                                        depressed
                                                        @click="createPlacement(item.id)"
                                                    >
                                                        <v-icon x-small color="#6F6F6F">fas fa-plus</v-icon></v-btn
                                                    >
                                                </template>
                                                <span>{{ $t('tooltips.createPlacement') }}</span>
                                            </v-tooltip>
                                        </td>
                                    </tr>
                                </TheTable>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import TheTable from './trinkets/TheTable';

export default {
    name: 'Seafarers',
    components: {TheTable},
    data: function () {
        return {
            seafarersTable: {
                selectedHeaders: [],
                headers: [
                    {text: '', value: 'checkbox', type: '', sortable: false, width: '30px', allowFilter: false},
                    {text: this.$t('fields.id'), value: 'id', type: 'string', width: '50px', allowFilter: true},
                    {
                        text: this.$t('fields.pendingAction'),
                        value: 'pending_status',
                        type: 'boolean',
                        default: null,
                        width: '150px',
                        allowFilter: true,
                    },
                    {
                        text: this.$t('fields.status'),
                        value: 'status_id',
                        type: 'multiple|seafarer-statuses-and-reasons',
                        width: '140px',
                        allowFilter: true,
                    },
                    {text: this.$t('fields.firstName'), value: 'name', type: 'string', width: '15%', allowFilter: true},
                    {
                        text: this.$t('fields.lastName'),
                        value: 'surname',
                        type: 'string',
                        width: '15%',
                        allowFilter: true,
                    },
                    {
                        text: this.$t('fields.nationality'),
                        value: 'nationality_id',
                        type: 'multiple|nationalities',
                        width: '150px',
                        allowFilter: true,
                    },
                    {text: this.$t('fields.age'), value: 'age', type: '', allowFilter: true},
                    {
                        text: this.$t('fields.availableDate'),
                        value: 'available_date',
                        type: 'date',
                        width: '130px',
                        allowFilter: true,
                    },
                    {
                        text: this.$t('fields.ranks'),
                        value: 'rank_id',
                        type: 'multiple|ranks-abbreviation',
                        allowFilter: true,
                    },

                    {
                        text: this.$t('fields.nextPlannedDate'),
                        value: 'next_planned_date',
                        type: 'boolean',
                        default: null,
                        width: '150px',
                        allowFilter: true,
                    },
                    {
                        text: this.$t('fields.overallFeedback'),
                        value: 'overall',
                        type: 'string',
                        allowFilter: true,
                    },
                    {
                        text: this.$t('fields.approved'),
                        value: 'approved',
                        type: 'boolean',
                        default: null,
                        width: '150px',
                        allowFilter: true,
                    },
                    {
                        text: this.$t('fields.rankExpirience'),
                        value: 'rank_expirience_id',
                        type: 'multiple|ranks',
                        width: '150px',
                        allowFilter: true,
                        sortable: false,
                    },
                    {
                        text: this.$t('fields.vesselExpirience'),
                        value: 'vessel_expirience_id',
                        type: 'multiple|vessel-types',
                        width: '150px',
                        allowFilter: true,
                        sortable: false,
                    },
                    {text: '', value: 'actions', type: '', sortable: false, width: '100px', allowFilter: false},
                ],
                additionalFilters: [],
                items: [],
                total: 0,
                lastRequest: null,
                height: '0px',
                defaultSort: {
                    field: 'name',
                    descending: true,
                },
            },
            selectAll: false,
            initialLoad: false,
        };
    },
    watch: {
        selectAll(newVal) {
            if (this.initialLoad) {
                if (newVal) {
                    this.seafarersTable.items.forEach((row) => {
                        row.checked = true;
                    });
                } else {
                    this.seafarersTable.items.forEach((row) => {
                        row.checked = false;
                    });
                }
            }
        },
    },
    methods: {
        openPlacement(placementId) {
            let routeData = this.$router.resolve('/placements/' + placementId);
            window.open(routeData.href, '_blank');
        },
        createPlacement(seafarerId) {
            let routeData = this.$router.resolve('/placements/-' + seafarerId);
            window.open(routeData.href, '_blank');
        },
        addClick() {
            this.$router.push('/seafarers/0');
        },
        editClick(id, newTab = false) {
            if (!newTab) {
                this.$router.push('/seafarers/' + id);
            } else {
                let routeData = this.$router.resolve('/seafarers/' + id);
                window.open(routeData.href, '_blank');
            }
        },
        copyCheckedEmailsToClipboard() {
            let rows = this.seafarersTable.items;
            let emailString = '';

            rows.forEach((row) => {
                if (row.checked === true) {
                    emailString += row.email + ';';
                }
            });

            this.copyToClipboard(emailString);
        },

        copyToClipboard(text) {
            navigator.clipboard
                .writeText(text)
                .then(() => {
                    this.$notify(this.$t('alerts.mailsSavedToClipboard'));
                })
                .catch(() => {
                    this.$notify(this.$t('alerts.failedToSaveMails'));
                });
        },
        selectHeaders(headers) {
            this.seafarersTable.selectedHeaders = headers;
        },
        reloadData(request) {
            this.lastRequest = request;
            let vm = this;
            this.$APICall('get', 'seafarers', request, (data, success) => {
                if (success) {
                    vm.seafarersTable.items = data.items;
                    vm.seafarersTable.total = data.total;
                    vm.initialLoad = true;
                } else {
                    vm.$alert(vm.$t('alerts.basicError'));
                }
            });
        },
        excelExport() {
            let excelRequest = JSON.parse(JSON.stringify(this.lastRequest));
            excelRequest.pagination.itemsPerPage = 999999999;
            excelRequest.pagination.page = 1;

            let vm = this;
            this.$APICall(
                'get',
                'seafarers',
                excelRequest,
                (data, success) => {
                    if (success) {
                        vm.$APICall('post', 'excel/seafarers', data.items, (data) => {
                            window.open(data.link);
                        });
                    } else {
                        vm.$alert(vm.$t('alerts.basicError'));
                    }
                },
                false,
            );
        },
        resolveWindowResize() {
            this.seafarersTable.height = window.innerHeight - 310 + 'px';
        },
    },
    mounted() {
        if (!this.$myStore.state.loggedIn) {
            this.$router.replace('login');
        }
        this.$myStore.commit('setBreadcrumbs', [
            {text: this.$t('modules.seafarers'), href: '/#/seafarers', disabled: true},
        ]);

        window.addEventListener('resize', this.resolveWindowResize);
        this.resolveWindowResize();
    },
};
</script>

<style scoped>
.truncate-content {
    max-width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
